import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color) => L.divIcon({
  className: "",
  html: `<div style="width:16px;height:16px;border-radius:9999px;background:${color};border:2.5px solid rgba(255,255,255,.9);box-shadow:0 0 12px ${color};"></div>`,
  iconSize: [16, 16], iconAnchor: [8, 8],
});

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length >= 2) map.fitBounds(L.latLngBounds(points), { padding: [28, 28] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(points.slice(0, 2)), points.length]);
  return null;
}

export function RouteMap({ route, className = "h-48" }) {
  if (!route?.pickup || !route?.dropoff) return null;
  const pts = [[route.pickup.lat, route.pickup.lng], [route.dropoff.lat, route.dropoff.lng]];
  const line = route.geometry?.length > 1 ? route.geometry : pts;
  return (
    <div className={`overflow-hidden rounded-2xl border cc-touch-native relative z-0 ${className}`} data-testid="route-map">
      <MapContainer center={pts[0]} zoom={10} className="map-dark-tiles" style={{ height: "100%", width: "100%", background: "#0a0c10" }}
        zoomControl={false} attributionControl={false} scrollWheelZoom={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Polyline positions={line} pathOptions={{ color: "#22D3EE", weight: 3.5, opacity: 0.85 }} />
        <Marker position={pts[0]} icon={pin("#22D3EE")} />
        <Marker position={pts[1]} icon={pin("#A78BFA")} />
        <Fit points={line} />
      </MapContainer>
    </div>
  );
}
